var _circle, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgVerifyProfile(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 124,
    height: 124,
    viewBox: "0 0 124 124",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 62,
    cy: 62,
    r: 62,
    fill: "#F9F9F9"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_507_10326)"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_d_507_10326)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M54.9066 79.3488H37.7207C36.7936 79.3488 35.9577 79.9074 35.6031 80.7638C35.2484 81.6203 35.4444 82.6063 36.1 83.2618L53.2859 100.448C53.9415 101.103 54.9274 101.299 55.7839 100.945C56.6404 100.59 57.1989 99.754 57.1989 98.8271V81.641C57.1988 80.3751 56.1725 79.3488 54.9066 79.3488Z",
    fill: "#C4CDD5"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M86.8232 101.119H54.9067C53.6408 101.119 52.6145 100.093 52.6145 98.8269V86.2252C52.6145 84.9594 51.5883 83.9331 50.3224 83.9331H37.7207C36.4548 83.9331 35.4286 82.9068 35.4286 81.641V25.1731C35.4286 23.9072 36.4548 22.881 37.7207 22.881H86.8232C88.0891 22.881 89.1153 23.9072 89.1153 25.1731V98.8269C89.1153 100.093 88.0891 101.119 86.8232 101.119Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 25.2107,
    height: 1.65722,
    rx: 0.828609,
    transform: "matrix(1 -3.3845e-08 -3.56499e-06 1 55.4597 43.7376)",
    fill: "#FBE0C0"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 17.0785,
    height: 1.65722,
    rx: 0.828609,
    transform: "matrix(1 -3.3845e-08 -3.56499e-06 1 55.3701 47.2762)",
    fill: "#FBE0C0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.2857 44.0714C44.2857 42.9668 45.1812 42.0714 46.2857 42.0714H51.1429C52.2474 42.0714 53.1429 42.9668 53.1429 44.0714L53.1428 48.9286C53.1428 50.0331 52.2474 50.9286 51.1428 50.9286H46.2857C45.1811 50.9286 44.2857 50.0331 44.2857 48.9286L44.2857 44.0714Z",
    fill: "#FBE0C0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50.0431 38.3809L49.8854 45.0415H48.2602L48.0314 38.3809H50.0431ZM47.9762 46.9405C47.9762 46.6498 48.0709 46.4066 48.2602 46.211C48.4548 46.0102 48.723 45.9097 49.0649 45.9097C49.4015 45.9097 49.6671 46.0102 49.8617 46.211C50.0563 46.4066 50.1536 46.6498 50.1536 46.9405C50.1536 47.2207 50.0563 47.4612 49.8617 47.6621C49.6671 47.8577 49.4015 47.9555 49.0649 47.9555C48.723 47.9555 48.4548 47.8577 48.2602 47.6621C48.0709 47.4612 47.9762 47.2207 47.9762 46.9405Z",
    fill: "#F5A342"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 25.2107,
    height: 1.65722,
    rx: 0.828611,
    transform: "matrix(1 -3.38451e-08 -3.56498e-06 1 55.4587 55.5471)",
    fill: "#C9D1DA",
    fillOpacity: 0.6
  }), /*#__PURE__*/React.createElement("rect", {
    width: 17.0785,
    height: 1.65722,
    rx: 0.828611,
    transform: "matrix(1 -3.38451e-08 -3.56498e-06 1 55.3693 59.0857)",
    fill: "#C9D1DA",
    fillOpacity: 0.6
  }), /*#__PURE__*/React.createElement("rect", {
    width: 8.85714,
    height: 8.85714,
    rx: 2,
    transform: "matrix(1 0 -3.53114e-06 1 44.2857 53.881)",
    fill: "url(#paint0_linear_507_10326)",
    fillOpacity: 0.6
  }), /*#__PURE__*/React.createElement("rect", {
    width: 25.2107,
    height: 1.65723,
    rx: 0.828613,
    transform: "matrix(1 -3.38452e-08 -3.56498e-06 1 55.4587 67.3566)",
    fill: "#C9D1DA",
    fillOpacity: 0.4
  }), /*#__PURE__*/React.createElement("rect", {
    width: 17.0785,
    height: 1.65723,
    rx: 0.828613,
    transform: "matrix(1 -3.38452e-08 -3.56498e-06 1 55.3693 70.8952)",
    fill: "#C9D1DA",
    fillOpacity: 0.4
  }), /*#__PURE__*/React.createElement("rect", {
    width: 8.85714,
    height: 8.85715,
    rx: 2,
    transform: "matrix(1 0 -3.53113e-06 1 44.2857 65.6905)",
    fill: "url(#paint1_linear_507_10326)",
    fillOpacity: 0.4
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_507_10326",
    x: 19.4286,
    y: 12.881,
    width: 77.6868,
    height: 102.238,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: -4,
    dy: 2
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 6
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.109804 0 0 0 0 0.239216 0 0 0 0 0.392157 0 0 0 0.03 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_507_10326"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_507_10326",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_d_507_10326",
    x: 23.3005,
    y: 65.0805,
    width: 46.0265,
    height: 46.0265,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: -2.14025
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 6.06403
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.108708 0 0 0 0 0.237823 0 0 0 0 0.391768 0 0 0 0.0690104 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_507_10326"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_507_10326",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_507_10326",
    x1: 4.60266,
    y1: 8.67199,
    x2: 3.89547,
    y2: 0.184152,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EBF0F7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.392372,
    stopColor: "#DAE2EC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C9D1DA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_507_10326",
    x1: 4.60266,
    y1: 8.672,
    x2: 3.89547,
    y2: 0.184152,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EBF0F7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.392372,
    stopColor: "#DAE2EC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C9D1DA"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVerifyProfile);
export default __webpack_public_path__ + "static/media/verify-profile.046abf73234c3634d44163b778e6e0d8.svg";
export { ForwardRef as ReactComponent };